<template>
  <div class="agreement">
    <h2>App隐私政策</h2>
    <div class="time">
      <div>更新日期: 2024年01月12日</div>
      <div>生效日期: 2024年01月12日</div>
    </div>
    <p>欢迎使用<span
				class="special">杺桉物联（以下简称“本应用”或“我们”）</span>，我们致力于为您提供更好的服务。本应用非常重视您的个人隐私保护。在使用本应用之前，请您务必仔细阅读本隐私政策（以下简称“本政策”）的全部内容，特别是加粗标注部分。您使用或继续使用本应用即表示您已经充分阅读、理解并同意本政策的全部内容。
		</p>
    <p>本条款目录如下：</p>
		<p>一、个人信息的定义与范围</p>
		<p>二、个人信息的收集</p>
		<p>三、个人信息的使用</p>
		<p>四、个人信息的共享、转让、公开披露</p>
		<p>五、个人信息的存储</p>
		<p>六、个人信息的安全保护措施和安全事件处置</p>
		<p>七、用户的个人信息处置权限</p>
		<p>八、未成年人保护</p>
		<p>九、变更</p>
		<p>十、如何联系我们</p>
    <p>本条款具体内容如下：</p>
    <h3>一、个人信息的定义与范围</h3>
		<p>1.1
			个人信息，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，在本隐私条款中包括<span
				class="special">姓名、手机号码、身份证或其他身份证明、照片、人脸面部识别特征、紧急联系人的姓名及联系方式、车辆信息、驾驶证、行驶证、车辆登记证、住址、运单信息、银行卡号、评价信息、日志信息、设备信息、通讯录、通信记录、使用的手机APP、位置信息。</span>
		</p>
		<p>1.2
			个人敏感信息，一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。在本隐私条款中包括<span
				class="special">手机号码、用户密码、身份证或其他身份证明、照片、人脸面部识别特征、征信信息、驾驶证、住址、银行卡号、IP地址、通讯录、通信记录、位置信息。</span>
		</p>
		<p>1.3 匿名化处理后的信息，即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程，匿名化处理后的信息不属于个人信息。</p>
		<h3>二、 个人信息的收集</h3>
		<p>2.1 您使用本应用服务前，<span class="special">需要向我们提供您的手机号码，如果您拒绝提供手机号码，我们无法为您创建账号并提供服务。</span></p>
		<p>2.2 如果您作为接单用户，使用本应用的接单服务需要向我们提供<span
				class="special">姓名、身份证、住址、车辆信息、驾驶证、行驶证、车辆登记证、人脸面部识别特征、位置信息、银行卡号，</span>以使我们能向您提供服务并保护您的信息安全。</p>
		<p>2.3 当您使用本应用服务时，我们会获取您的<span class="special">通讯录、通讯记录、手机app，</span>以便于我们的反欺诈部门进行核查，保护交易各方的财产安全。</p>
		<p>2.4 当您使用本应用服务时，<span
				class="special">我们将记录您的运单信息、运单状态、收支信息，</span>我们收集上述信息基于法律法规要求以及保护您的财产安全，依据本应用规则处理用户纠纷之需要。</p>
		<p>2.5 您在本应用上进行交易支付时，如果您使用第三方支付功能，本应用除获取您的的支付工具及订单支付状态外，不会获取其他个人信息。</p>
		<p>2.6
			当您与我们客服团队联系时，我们会以通话录音及人工录入的方式记录您的通话信息，您提出的意见或建议，您提供的姓名、联系方式、以便于我们处理纠纷、解决问题或向您反馈结果，如果您拒绝我们收集此类信息，会导致您无法拨打我们的客服电话或客服团队无法将处理结果反馈到您，但不影响您使用本应用核心业务功能。
		</p>
		<p>2.7
			为开展数据分析和更好改善本应用服务，我们会收集您的日志信息和Cookie数据，包括检索内容、IP地址、设备信息（包括设备型号、设备识别码、操作系统、分辨率、电信运营商）、位置信息、收支信息、运单信息。我们会使用浏览器网络存储机制和应用程序数据缓存，在您的设备上收集信息并进行本地存储。
		</p>
		<p>2.8 本应用的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI
			信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。<a
				href="https://ask.dcloud.net.cn/protocol.html">（DCloud用户服务条款超链至：https://ask.dcloud.net.cn/protocol.html）</a></p>
		<p>2.9 <span class="special">我们的应用程序包括一个实名认证功能，用于对司机进行身份验证。在此过程中，我们使用了人脸数据来进行认证，但我们严格保证不会保留或存储这些数据。一旦认证成功，即刻自动删除用户的人脸数据，我们不会持续保留任何与人脸相关的信息。</span></p>
		<p>2.10 本应用集成了高德开放平台定位SDK, 目的是为了保证司机装货和卸货时的真实位置信息。我们会收集位置信息、设备信息（包括IMEI、IDFA、Android
			ID、MEID、MAC地址、OAID、IMSI、硬件序列号）。</p>
		<p>2.11 本应用集成(高德地图)SDK，目的是为了保证司机装货和卸货时的真实位置信息。我们会收集位置信息、设备信息（包括IMEI、IDFA、Android
			ID、MEID、MAC地址、OAID、IMSI、硬件序列号）。</p>
		<p>2.12 本应用集成了高德开放平台猎鹰SDK，目的是为了动态获取司机行程轨迹并上传，以便后台对司机的行程路线进行可视化操作。我们会收集位置信息、设备信息（包括IMEI、IDFA、Android
			ID、MEID、MAC地址、OAID、IMSI、硬件序列号）。</p>
		<p>2.13 我们可能从第三方获取您授权共享的个人信息，我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>
		<p>2.14 本应用集成腾讯Bugly收集AndroidId进行分析崩溃日志，以优化用户体验。</p>
		<p>2.15 本应用集成（神策）SDK，目的是为了动态获取司机及货主操作并上传，以便确认司机及货主的真实性操作。我们会收集用户行为数据‌、设备信息（包括IMEI、IDFA、AndroidID、MEID、MAC地址、OAID、IMSI、硬件序列号）。</p>
		<p>2.16 您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
		<p>（1） 与国家安全、国防安全有关的；</p>
		<p>（2） 与公共安全、公共卫生、重大公共利益有关的；</p>
		<p>（3） 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
		<p>（4） 所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
		<p>（5） 从合法公开披露的信息中收集的您的个人信息；</p>
		<p>（6） 根据您的要求签订合同所必需的；</p>
		<p>（7） 法律法规规定的其他情形。</p>
    <h3>三、 个人信息的使用</h3>
		<p>3.1 您的个人信息会被用于“个人信息的收集”条款列明的使用场景。</p>
		<p>3.2
			为了反欺诈的目的，我们会使用您的个人信息向中国人民银行金融信用信息基础数据库等依法成立的征信机构、金融机构、公安部公民身份信息数据库、检察院、法院及其他有关政府机构、信息机构、独立第三方采集、查询、使用、打印、保存您的个人信息，并可以依法向上述机构披露、报送以上信息及资料，且上述机构可以依法向其他数据源机构查询、整理、保存并向我们提供经其验证过的您的个人信息。
		</p>
		<p>3.3 我们会对用户个人信息进行核验用户身份识别以及真实性。</p>
		<p>3.4 我们会对用户个人信息统计数据为基础设计、开发、推广新的产品、服务。</p>
		<p>3.5 我们会向您发送短信，目的是为了通过短信验证码授权登录、注册。</p>
		<p>3.6 凡是超出与“个人信息的收集”条款声称目的具有直接或合理关联的范围使用您的个人信息，我们会再次向您告知并征得您的明示同意。</p>
    <h3>四、 个人信息的共享、转让、公开披露</h3>
		<p>4.1 我们将遵守相关法律法规，对您的个人信息予以保密，除以下情况外，我们不会向其他人共享您的个人信息：</p>
		<p>（1） 事先获得您的明确的同意或授权；</p>
		<p>（2） 只有共享您的个人信息，才能提供您所需要的服务和产品；</p>
		<p>（3） 为了反欺诈的目的，与授权合作伙伴共享；</p>
		<p>（4） 为了提升我们的产品及服务质量或向您提供全新的产品及服务，我们会在关联公司内部共享您的相关信息；</p>
		<p>（5） 为维护用户的合法权益，在协助处理与您有关的交易纠纷或争议时，我们可能向您的交易相对方或存在利害关系的第三方提供解决交易纠纷或争议所必须的信息；</p>
		<p>（6） 符合与您签署的相关协议或其他法律文件约定所提供的；</p>
		<p>（7） 根据法律规定，刑事侦查机关为调查犯罪，依法定程序调取的必要个人信息，或行政机关、司法机构，依法定程序并经您授权同意调取的必要个人信息；</p>
		<p>（8） 在法律要求或准许范围内，为了保护社会公共利益、财产或安全而提供必要的信息。</p>
		<p>4.2
			非经法定程序或获得您的同意，我们不会将您的个人信息提供给任何第三方机构或个人，对我们与之共享个人信息的公司、组织和个人，我们会与之签署严格的协议，要求他们按照我们的说明，本隐私政策及其他任何相关的保密和安全措施来处理个人信息。
		</p>
		<p>4.3 我们将遵守相关法律法规，对您的个人信息予以保密，除非事先获得您的明确同意或授权，或依照法律规定所必须，我们不会公开披露您的个人信息。</p>
		<p>4.4 如发生收购、兼并、重组等变更，我们会要求变更后的主体依然遵守本隐私条款的约定，履行原有的责任及义务，如变更后的主体需变更个人信息使用目的，我们会要求其事先获得您的明示同意。</p>
		<p>4.5 我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：</p>
		<p>（1） 根据您的要求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
		<p>（2） 根据法律法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下。</p>
    <h3>五、 个人信息的存储</h3>
		<p>5.1 在您使用本应用服务期间，我们会持续保存您的个人信息。</p>
		<p>5.2 当您不在使用本应用服务后，我们将在法律法规要求的最短保存期限内仍然保存您的个人信息，当超出上述保存期限，我们将对其进行匿名化处理。</p>
		<p>5.3 如果您在使用本应用服务时，存在严重违反法律法规、本应用协议、本应用规则等情形，您的违法、违约记录及相应在本应用的信用记录，将被永久保存。</p>
		<p>5.4 我们收集的您的个人信息，将在中国内地存储和使用。</p>
		<p>5.5 目前本应用不存在向境外提供个人信息的场景。如将来涉及向境外传输个人信息，我们将明确向您告知个人信息出境的目的、接收方、安全保障措施等情况，并明确征得您的同意。</p>
    <h3>六、 个人信息的安全保护措施和安全事件处置</h3>
		<p>6.1 本应用采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不丢失、泄露、毁损或被未经授权的访问、使用。</p>
		<p>6.2 本应用采取以下安全技术措施保护您的个人信息：</p>
		<p>（1） 用户个人信息被加密储存在服务器中。</p>
		<p>（2） 严格控制数据访问权限，设立完善的敏感数据访问权限申请、审批制度。</p>
		<p>6.3 本应用同时采取其他安全措施保护您的个人信息</p>
		<p>（1） 与涉密员工和服务外包公司及其派驻人员签署保密协议，并按照工作职责严格限制数据访问权限。</p>
		<p>（2） 定期开展面向本应用全体员工及外包服务人员的信息安全教育及培训。</p>
		<p>6.4 我们将及时推送通知、电话等方式将安全事件告知受影响的用户，当难以逐一告知用户时，我们将通过发布公告的方式发布警示信息。</p>
		<p>6.5 如果本应用停止运营，我们将及时停止收集个人信息。</p>
		<p>6.6 停止运营后，我们将停止对个人信息的商业化使用，并在满足法律法规的最短保存期后，对收集的个人信息进行匿名化处理</p>
    <h3>七、 用户的个人信息处置权限</h3>
		<p>7.1 您可以通过您在本应用的账户访问您提供的个人资料、运单信息、收支信息。</p>
		<p>7.2 如您需要更新您的个人信息，或发现本应用收集、存储的个人信息有错误时，您需要做出更正或更新，您可以联系我们客服团队进行更改或更新，在验证您的身份后，我们客服团队将为您进行更改或更新</p>
		<p>7.3
			删除个人信息，如您希望删除个人信息，可以联系客服团队，在验证身份后，您可以提交删除申请，如您在本应用与各方的交易均已正合法常终止且本应用对您个人信息的保存满足法律法规要求的最短保存期限要求的情况下，我们将对您的个人信息进行删除或匿名化处理，在上述法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。但当本应用存在以下情形时，您删除个人信息的申请将不受法律法规要求的最短保存期限限制：
		</p>
		<p>（1） 本应用违反法律、行政法规的规定收集、使用您的个人信息。</p>
		<p>（2） 违反我们双方的约定收集、使用您的个人信息。</p>
		<p>7.4
			注销账号，您可以联系我们客服团队<span
				class="special">(邮箱：wxyu@cmwood123.com.cn)</span>注销您的账号，在我们客服团队验证您的身份后，确保您与各方之间的全部交易均已合法正常终止，客服团队将根据您的要求在5-7个工作日内注销账号。
		</p>
		<p>7.5 删除个人信息或注销账号，除法律法规另有规定外，本应用将停止为您提供服务，并根据本条款约定期限保存您的个人信息，保存期限届满后我们将对您的个人信息进行匿名化处理。</p>
		<p>7.6 在以下情形中，按照法律法规要求，我们将无法响应您关于个人信息的请求：</p>
		<p>（1）与国家安全、国防安全有关的；</p>
		<p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
		<p>（3）与犯罪侦查、起诉和审判等有关的；</p>
		<p>（4）有充分证据表明您存在主观恶意或者滥用权里的；</p>
		<p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
    <h3>八、未成年人保护</h3>
		<p>8.1.
			本应用非常重视对未成年人信息的保护，如果您是未满18周岁的未成年人，您的监护人需要仔细阅读本条款并授权您同意依照本条款使用本应用。如果您是未满14周岁的未成年人，您的监护人需要仔细阅读本条款并同意您依照本条款使用本应用的服务。
		</p>
		<p>8.2. 如果您/您的监护人不同意本隐私政策的任何内容，您应立即停止使用本应用的服务。</p>
    <h3>九、变更</h3>
		<p>9.1 如果本应用发生以下变化，我们将对本条款进行相应的修订：</p>
		<p>（1） 本应用业务功能发生变更；</p>
		<p>（2） 用户个人信息保存地域发生变更；</p>
		<p>（3） 用户个人信息的使用规则发生变更；</p>
		<p>（4） 我们的联络方式及投诉渠道发生变更；</p>
		<p>（5） 发生其他可能影响用户个人信息安全或影响用户隐私权利的变更等。</p>
		<p>9.2 隐私条款修订后，我们会在本应用发布最新版本，并以推送通知的方式告知用户，以便用户及时了解最新版本隐私政策。</p>
		<p>9.3 未经您的明确同意，我们不会削减您按照本条款所享有的权利。</p>
		<p>9.4 如无特殊说明，修订后的隐私条款自公布之日起生效。</p>
    <h3>十、如何联系我们</h3>
    <p>10.1 我们的运营主体是<span class="special">福建杺桉科技有限公司</span>，注册地址是<span class="special">福建省莆田市湄洲湾北岸经济开发区经济城1077号</span></p>
    <p>10.2 如果您对本隐私政策和个人信息保护有任何疑问或者建议，请您通过以下电子邮箱与我们负责个人信息保护的法务部取得联系，<span class="special">电子邮箱地址：wxyu@cmwood123.com.cn</span></p>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Indicator,
  Toast,
  Lazyload,
  InfiniteScroll,
  Header,
  Button,
  Field,
} from "mint-ui";
import Vue from "vue";
Vue.component(Header.name, Header);
Vue.component(Button.name, Button);
export default {
  name: "Login",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  width: 93.6%;
  margin-left: auto;
  margin-right: auto;
}
.agreement h2 {
  font-size: 17px;
  color: #2c2c2c;
  line-height: 35px;
  font-weight: 600;
}
.agreement p {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  text-align: left;
  line-height: 20px;
  margin-bottom: 10px;
  text-align: justify;
  text-justify: inter-ideograph;
}
.agreement h3 {
  font-size: 16px;
  color: #2c2c2c;
  font-weight: 600;
  line-height: 30px;
}
.special {
  font-weight: 700;
  color: #333333;
}
.time {
  text-align: right;
  margin-bottom: 10px;
  font-size: 28upx;
  font-weight: 500;
  color: #333333;
  margin-top: 20upx;
}
</style>



// WEBPACK FOOTER //
// src/components/xinanprivacyClause.vue